import { Draft, produce } from "immer";

export abstract class Subscribable<T> {
  private _state: T;

  protected constructor(initialState: T) {
    this._state = initialState;
  }
  private subscribers: (() => void)[] = [];

  subscribe = (callback: () => void) => {
    this.subscribers.push(callback);
    return () => {
      this.subscribers = this.subscribers.filter((sub) => sub !== callback);
    };
  };

  getState = () => this._state;

  private _notify = () => {
    this.subscribers.forEach((sub) => sub());
  };

  protected updateState(recipe: (draft: Draft<T>) => void): void {
    this._state = produce(this._state, recipe);
    this._notify();
  }
}
